
import React from 'react';
import CityMetauxPage from '@/components/valorisation/CityMetauxPage';

const AchatMetauxCarmaux = () => {
  return (
    <CityMetauxPage
      cityName="Carmaux"
      departmentName="Tarn"
      departmentCode="81"
      region="Occitanie"
      description="Ancienne cité minière du Tarn avec un riche passé industriel, Carmaux bénéficie de notre expertise dans le rachat de métaux issus de l'industrie extractive, de la métallurgie et du patrimoine industriel."
      specialities={[
        "Métaux de l'industrie minière",
        "Équipements de métallurgie",
        "Ferraille de patrimoine industriel",
        "Métaux de construction lourde"
      ]}
      nearbyAreas={[
        "Blaye-les-Mines", "Saint-Benoît-de-Carmaux", "Cagnac-les-Mines", "Le Garric", "Rosières", "Monestiés"
      ]}
      heroImage="https://images.unsplash.com/photo-1565106430482-8f6e74349ca1?w=1280&q=80"
    />
  );
};

export default AchatMetauxCarmaux;
